import VinculoPage from './views/VinculoPage';
export default VinculoPage;
export { default as SelectVinculoLinha } from './views/selectVinculoLinha';
export { default as AcoesVinculoTab } from './views/acoesVinculoTab';
export { default as ConteudoTabVinculo } from './views/conteudoTabVinculo';
